import { useId } from 'react';
import { DashboardPageFormField } from '@shigo-ui/dashboard-ui';

import { dashboardT } from '../../../../lib/messages';
import type { TargetingFormValue } from '../../model';
import type { TargetingFormUpdate } from './TargetingForm.types';
import { InclusionToggle } from './InclusionToggle';
import { TargetingSection } from './TargetingSection';
import { TargetingTextarea } from './TargetingTextarea/TargetingTextarea';

export function ClassicDomainsTargetingSection({
  updateField,
  value,
}: {
  updateField: TargetingFormUpdate;
  value: TargetingFormValue;
}) {
  const fieldId = useId();

  return (
    <TargetingSection
      title={dashboardT('supply.domains')}
      action={
        <InclusionToggle
          included={value.domainsIncluded}
          onIncludedChange={(included) => {
            updateField('domainsIncluded', included);
          }}
        />
      }
    >
      <DashboardPageFormField label={dashboardT('targeting.domainList')} htmlFor={fieldId}>
        <TargetingTextarea
          id={fieldId}
          copyLabel={dashboardT('targeting.domainList')}
          placeholder={dashboardT('targeting.domainsPlaceholder')}
          value={value.domainsText}
          onChange={(event) => {
            updateField('domainsText', event.target.value);
          }}
        />
      </DashboardPageFormField>
    </TargetingSection>
  );
}
